<div class="wrap">
  <h1 class="module-heading">{{ 'pages.user-receipts.header' | translate }}</h1>
  <div class="loading" *ngIf="loading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="20"
    ></mat-progress-spinner>
  </div>
  <div class="receipts" *ngIf="!loading">
    <div class="empty-list" *ngIf="receipts.length === 0">
      <p>{{ 'pages.user-receipts.no-receipts' | translate }}</p>
    </div>
    <app-user-receipt-summary 
      *ngFor="let item of receipts"
      [data]="item" 
      (click)="openReceiptDetailsDialog(item)">
    </app-user-receipt-summary>

    <div class="paginator-wrap">
      <mat-paginator
        [length]="myReceiptsPageOptions.length"
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageSize]="myReceiptsPageOptions.pageSize"
        [pageIndex]="myReceiptsPageOptions.page"
        showFirstLastButtons
        (page)="myReceiptsPageChange($event)"
      ></mat-paginator>
    </div>
  </div>
</div>